import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable, Subject, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import {
  NgbdSortableHeader,
  SortEvent,
} from "src/app/shared/directive/sortable.directive";
import { TableService } from "src/app/shared/services/table/table.service";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  loadingLocationPartnersSelector,
  locationPartnerCreatedSelector,
  locationPartnerDeletedByEmailSelector,
  locationPartnerFilterSelector,
  locationPartnersResultSelector,
} from "src/app/store/locationPartner/location-partner.selectors";
import { initialState } from "src/app/store/locationPartner/location-partner.reducers";
import { IColumn } from "src/app/shared/models/table/column.interface";
import { LocationPartnersFilterInterface } from "src/app/shared/models/location-partners/locationPartnersFilter.interface";
import { LocationPartnersResultInterface } from "src/app/shared/models/location-partners/locationPartnersResult.interface";
import { FormBuilder, FormGroup } from "@angular/forms";
import {
  PartnerStatus,
  PartnerStatusToShow,
  PartnerStatusInterface,
} from "src/app/shared/enum/partner-status";
import {
  InternetProvider,
  InternetProviderInterface,
  InternetProvidersToShow,
} from "src/app/shared/enum/internet-providers";
import {
  PaymentFrequency,
  PaymentFrequencyEnumMapping,
  PaymentFrequencyInterface,
} from "src/app/shared/enum/payment-frequency";
import { DateViewType } from "@danielmoncada/angular-datetime-picker";
import { BadgeService } from "src/app/shared/services/badge.service";
import {
  PricingMethod,
  PricingMethodEnumMapping,
  PricingMethodInterface,
} from "src/app/shared/enum/pricing-method";
import { LocationPartnerInterface } from "src/app/shared/models/location-partners/locationPartner.interface";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { ToastrService } from "ngx-toastr";
import { allTagNamesSelector } from "src/app/store/tag/tag.selectors";
import {
  allSubCategoryNamesSelector,
  selectedSubCategoriesSelector,
} from "src/app/store/subCategory/subCategory.selectors";
import { invokeAllSubGategoryNames } from "src/app/store/subCategory/subCategory.actions";
import { invokeAllTagNames } from "src/app/store/tag/tag.actions";
import { UpdateComponent } from "src/app/shared/components/drop-zone-options/modal/update/update.component";
import { updateFieldsSelector } from "src/app/store/settings/settings.selectors";
import { OptionActionInterface } from "src/app/shared/models/option-action.interface";
import {
  saveUpdateFields,
  updateFields,
} from "src/app/store/settings/settings.actions";
import { OwlOptions } from "ngx-owl-carousel-o";
import {
  invokeLocationPartnerFilter,
  invokeLocationPartners,
} from "src/app/store/locationPartner/actions/get-locations.actions";
import { TranslateService } from "@ngx-translate/core";
import { ExportComponent } from "src/app/shared/components/export/export.component";
import { saveAs } from "file-saver";
import {
  ActionInterface,
  ActionReturned,
  createLocation,
  FranchisedOfFranchiseActions,
  locationActions,
  OptionActionEnum,
  updateLocation,
} from "src/app/shared/data/actions-data";
import { saveSelectedRegionSelector } from "src/app/store/region/region.selectors";
import { saveSelectedZonesSelector } from "src/app/store/zone/zone.selectors";
import { saveSelectedRegion } from "src/app/store/region/region.actions";
import { saveSelectedZone } from "src/app/store/zone/zone.actions";
import { DeleteComponent } from "src/app/shared/components/drop-zone-options/modal/delete/delete.component";
import { DetailsLpComponent } from "src/app/shared/components/details-modal/details-lp/details-lp.component";
import { TypeCards } from "src/app/shared/enum/typeCards";
import {
  FilterInterface,
  locationFilter,
} from "src/app/shared/data/filter-data";
import {
  deleteLocationPartnerSuccess,
  selectedLPs,
  createLocationPartnerSuccess,
  invokeDeleteLocationPartner,
} from "src/app/store/locationPartner/location-partner.action";
import { invokeApiDistroyed } from "src/app/store/apiState.interface";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import {
  catchForbiddenErrorSelector,
  resultArchiveUserSelector,
} from "src/app/store/user/user.selectors";
import {
  catchForbiddenError,
  invokeArchiveUser,
  resultArchiveUser,
} from "src/app/store/user/user.actions";
import { Authorities } from "src/app/shared/enum/authorities";
import { JwtService } from "src/app/shared/services/jwt.service";
import { VouchersComponent } from "./vouchers/vouchers.component";
import { ApiKeyComponent } from "src/app/shared/components/api-key/api-key.component";
import { FeaturesComponent } from "./features/features.component";
import { invokeAllAvailableFeatures } from "src/app/store/features/features.actions";
import { UpdatePasswordComponent } from "src/app/shared/components/drop-zone-options/modal/update-password/update-password.component";
import { FiltersService } from "src/app/shared/services/filters.service";
import { FilterParams } from "src/app/shared/models/filterParams";
import { Constants } from "src/app/shared/data/constants";
import {
  UserStatus,
  UserStatusEnumMapping,
} from "src/app/shared/enum/user-status";
import { UtilFunctions } from "src/app/utils/utilFunctions";
import { ConfirmationModalComponent } from "src/app/shared/components/modal/confirmation-modal/confirmation-modal.component";
import { CreateLocationPartnerComponent } from "./create-location-partner/create-location-partner.component";
import { Router } from "@angular/router";
import { invokeLocationsByFranchise } from "src/app/store/franchise/franchise.action";
import { franchiseLocationsResultSelector } from "src/app/store/franchise/franchise.selectors";
import { FranchiseStatus } from "src/app/shared/enum/franchise-status.enum";
import { CompareModalComponent } from "src/app/shared/components/modal/compare-modal/compare-modal.component";
import { ApprobationProgressComponent } from "src/app/shared/components/approbation-progress/approbation-progress.component";
import { RoleEnum } from "src/app/shared/models/user/role.interface";

@Component({
  selector: "app-location-partners",
  templateUrl: "./location-partners.component.html",
  styleUrls: ["./location-partners.component.scss"],
})
export class LocationPartnersComponent extends BaseComponent implements OnInit {
  deletedIsLoading: any;

  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  @ViewChild("value") mySelect: ElementRef;

  isFranchise: boolean = false;

  demographic: IColumn[] = [
    {
      key: "region",
      label: "admin.locations.repository.region",
      sorter: true,
    },
    {
      key: "zone",
      label: "admin.locations.repository.zone",
      sorter: true,
    },
    {
      key: "category",
      label: "admin.locations.repository.category",
      sorter: true,
    },
    {
      key: "subCategory",
      label: "admin.locations.repository.subCategory",
      sorter: true,
    },
    {
      key: "tags",
      label: "admin.locations.repository.tags",
      sorter: true,
    },
  ];
  info: IColumn[] = [
    {
      key: "option",
      label: "Option",
      sorter: true,
    },
    {
      key: "endPurshaseDate",
      label: "admin.locations.repository.endPhase",
      sorter: true,
    },
  ];
  coordinates: IColumn[] = [
    {
      key: "name",
      label: "admin.locations.repository.responsable",
      sorter: true,
    },
    {
      key: "email",
      label: "admin.locations.repository.email",
      sorter: true,
    },
    {
      key: "phone",
      label: "admin.locations.repository.phone",
      sorter: true,
    },
    {
      key: "address",
      label: "admin.locations.repository.address",
      sorter: true,
    },
  ];
  discount: IColumn[] = [
    {
      key: "price",
      label: "admin.locations.repository.price",
      sorter: true,
    },
    {
      key: "paymentFrequency",
      label: "admin.locations.repository.priceFrequency",
      sorter: true,
    },
  ];
  formFilter: FormGroup;
  isLoading$: Observable<boolean | null>;
  orderHeader: String = "";
  pageSize: number = Constants.defaultTableSize;
  pageNumber: number = 1;

  locationPartnersResult$: Observable<LocationPartnersResultInterface | null>;
  locationPartnersResult: LocationPartnersResultInterface | null;

  locationCreated$: Observable<SuccessDto | null>;
  closeModal: Subject<boolean> = new Subject<boolean>();

  tags$: Observable<string[] | null>;

  subcategories$: Observable<string[] | null>;

  locationPartnerFilter$: Observable<LocationPartnersFilterInterface>;
  locationPartnerFilter: LocationPartnersFilterInterface = {
    ...initialState.locationPartnerFilter,
    pager: {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
    },
  };

  deleted$: Observable<SuccessDto | null>;

  partnerStatus: PartnerStatusInterface[];
  internetProvider: InternetProviderInterface[];
  paymentFrequency: PaymentFrequencyInterface[];
  pricingMethod: PricingMethodInterface[];
  value2: number = 100;
  maxvalue: number = 70;
  options: ActionInterface[] = locationActions;
  updateLocation: ActionInterface[] = updateLocation;
  createLocation: ActionInterface[] = createLocation;
  filter: FilterInterface = locationFilter;
  productionDateRange: any;
  years: DateViewType;
  selectedCityIds2: any;
  Placeholder: any;
  locationPartner: LocationPartnerInterface;
  update: OptionActionInterface = {
    name: [],
    icon: [],
    optionSelected: null,
    title: "",
  };
  owlcarousel1ptions: OwlOptions;
  zones: string[] = [];
  updateFields$: Observable<OptionActionInterface | null>;

  loading: boolean | null;
  columnVisibility: boolean[] = [true, true, true, true];
  colspan: number[] = [5, 3, 4, 3];

  selectedLocations: string[] = [];
  selectedRegion: string[] = [];
  selectedRegion$: Observable<string[] | null>;
  selectedZones$: Observable<string[] | null>;
  selectedZones: string[] = [];

  show: boolean[] = [false];

  selectedSubCategories$: Observable<string[] | null>;
  selectedSubCategories: string[];
  fields: OptionActionInterface = {
    name: [],
    icon: [],
    optionSelected: null,
    title: "",
  };
  optionSelected: PartnerStatus | null;
  pricingMethode = PricingMethod;
  paymentFrequencyToShow = PaymentFrequency;

  catchForbiddenError$: Observable<boolean | null>;
  forbidden: boolean | null = false;

  isAuthorised: boolean;

  filters: FilterParams | null = null;

  userStatusEnumMapping = UserStatusEnumMapping;

  archiveModal: NgbModalRef;

  resultArchiveUser$: Observable<SuccessDto | null>;
  roleName : RoleEnum
  constructor(
    private store: Store<AppStateInterface>,
    public service: TableService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private translate: TranslateService,
    public badgeService: BadgeService,
    private modalService: NgbModal,
    private saveHistory: SaveUserHistoryService,
    private jwtService: JwtService,
    private filtersService: FiltersService,
    private route: Router
  ) {
    super(store);

    this.isFranchise = this.route.url.includes("/dashboard/franchise/");

    if (this.isFranchise) {
      this.options = FranchisedOfFranchiseActions;
    } 

    if (!this.isFranchise) {
      this.info.push({
        key: "archiveStatus",
        label: "user.status.title",
        sorter: true,
      });
    }

    this.tags$ = this.store
      .pipe(select(allTagNamesSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.subcategories$ = this.store
      .pipe(select(allSubCategoryNamesSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.locationPartnerFilter$ = this.store
      .pipe(select(locationPartnerFilterSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    if (this.isFranchise) {
      this.locationPartnersResult$ = this.store
        .pipe(select(franchiseLocationsResultSelector))
        .pipe(takeUntil(this.ngDestroyed$));
    }
    else {
      this.locationPartnersResult$ = this.store
        .pipe(select(locationPartnersResultSelector))
        .pipe(takeUntil(this.ngDestroyed$));
    }

    if (!this.isFranchise) {
      this.isLoading$ = this.store
        .pipe(select(loadingLocationPartnersSelector))
        .pipe(takeUntil(this.ngDestroyed$));
    }

    this.deleted$ = this.store
      .pipe(select(locationPartnerDeletedByEmailSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.locationCreated$ = this.store
      .pipe(select(locationPartnerCreatedSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.updateFields$ = this.store
      .pipe(select(updateFieldsSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.selectedRegion$ = this.store
      .pipe(select(saveSelectedRegionSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.selectedZones$ = this.store
      .pipe(select(saveSelectedZonesSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.selectedSubCategories$ = this.store
      .pipe(select(selectedSubCategoriesSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.resultArchiveUser$ = this.store
      .pipe(select(resultArchiveUserSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.formFilter = this.fb.group({
      companyName: [""],
    });

    this.roleName = jwtService.getRoleName(jwtService.getToken())
    const authorities = this.jwtService.getPermissions(jwtService.getToken());
    if (authorities) {
      this.isAuthorised = authorities.includes(
        Authorities.LP_CREATE.toString()
      );
      
      if(this.roleName === RoleEnum.ROLE_ADMIN){
        this.forbidden = !authorities.includes(Authorities.LP_GETALL.toString());
      }

      if(this.roleName === RoleEnum.ROLE_FRANCHISE){
        this.forbidden = !authorities.includes(Authorities.FR_ASSOCIATED_LOCATIONS_LIST.toString());
      }
      
    }

    this.extractFilters();
  }

  extractFilters() {
    this.filters = this.filtersService.decodeUri();
    if (this.filters) {
      this.optionSelected = this.findOption(this.filters.status) ?? null;
      this.locationPartnerFilter.regions =
        this.filtersService.extractArrayValueFromUrl(
          this.filters,
          "regions",
          this.selectedRegion
        );
      this.locationPartnerFilter.zoneNames =
        this.filtersService.extractArrayValueFromUrl(
          this.filters,
          "zones",
          this.selectedZones
        );
    }
    this.pageNumber = this.filtersService.extractValueFromUrl(
      this.filters,
      "page",
      this.pageNumber
    );
    this.pageSize = this.filtersService.extractValueFromUrl(
      this.filters,
      "size",
      this.pageSize
    );

    this.filtersService.patchFormValue(
      this.filters,
      ["companyName"],
      this.formFilter
    );

    this.locationPartnerFilter = {
      ...this.locationPartnerFilter,
      companyName: this.formFilter.get("companyName")?.value,
      pager: {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      },
    };
  }

  ngOnInit(): void {
    this.resultArchiveUser$.subscribe((result) => {
      if (result) {
        if (result.message !== "UPDATE_USER_PASSWORD_SUCCESSFULLY_MESSAGE") {
          this.toastr.success(
            this.translate.instant("response.success." + result.message),
            this.translate.instant("response.successTitle")
          );
        }
        this.store.dispatch(resultArchiveUser({ successMessage: null }));
        this.store.dispatch(invokeLocationPartners());
        this.archiveModal.close();
      }
    });
    this.catchForbiddenError$.subscribe((result) => {
      if (result) {
        this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
      }
    });
    this.filter.name.map(
      (e) =>
        (e.data = Object.keys(PartnerStatus)
          .filter((value) => isNaN(Number(value)) === true)
          .map(
            (key: string | any) =>
              PartnerStatusToShow[key as keyof typeof PartnerStatus]
          ))
    );
    this.store.dispatch(deleteLocationPartnerSuccess({ successMessage: null }));
    this.store.dispatch(saveSelectedRegion({ selectedRegion: null }));
    this.store.dispatch(saveSelectedZone({ selectedZones: null }));
    this.store.dispatch(selectedLPs({ selectedLps: null }));
    this.store.dispatch(invokeAllAvailableFeatures());
    this.selectedSubCategories$.subscribe((result) => {
      if (result) {
        this.selectedSubCategories = result;
        this.locationPartnerFilter.subcategories = result;
        this.loadData();
      }
    });
    this.selectedZones$.subscribe((data) => {
      if (data) {
        this.selectedZones = data;
        this.pageNumber = 1;
        this.locationPartnerFilter = {
          ...this.locationPartnerFilter,
          zoneNames: this.selectedZones,
          pager: {
            ...this.locationPartnerFilter.pager,
            pageNumber: this.pageNumber,
          },
        };
        this.loadData();
      }
    });
    this.selectedRegion$.subscribe((data) => {
      if (data) {
        this.pageNumber = 1;
        this.selectedRegion = data;
        this.locationPartnerFilter = {
          ...this.locationPartnerFilter,
          regions: this.selectedRegion,
          pager: {
            ...this.locationPartnerFilter.pager,
            pageNumber: this.pageNumber,
          },
        };
        this.loadData();
      }
    });

    if (!this.isFranchise) {
      this.isLoading$.subscribe((data) => {
        this.loading = data;
      });
    }

    this.store.dispatch(invokeAllSubGategoryNames());
    this.store.dispatch(invokeAllTagNames());
    this.loadData();
    this.locationPartnerFilter$.subscribe(
      (result: LocationPartnersFilterInterface) => {
        if (result != null) {
          this.locationPartnerFilter = result;
          this.pageNumber = result.pager.pageNumber;
          if (this.isFranchise) {
            const companyName = this.jwtService.getCompanyName();
            this.store.dispatch(invokeLocationsByFranchise({ companyName }));
          }
          else {
            this.store.dispatch(invokeLocationPartners());
          }
        } else {
          this.saveHistory.saveUserHistory(
            UserHistoryActionsEnum.GET,
            UserHistoryServicesEnum.LIST_LOCATIONS
          );
        }
      }
    );
    this.locationPartnersResult$.subscribe(
      (result: LocationPartnersResultInterface | null) => {
        if (result) {
          this.locationPartnersResult = result;
          if(result.locationPartners.length>0){
            result.locationPartners.map((value) => {
              this.zones.push(value.zoneName);
            });
          }
        }
      }
    );
    this.locationCreated$.subscribe((data) => {
      if (data) {
        this.toastr.success(
          this.translate.instant("response.success." + data.message),
          this.translate.instant("response.successTitle")
        );
        if (this.isFranchise) {
          const companyName = this.jwtService.getCompanyName();
          this.store.dispatch(invokeLocationsByFranchise({ companyName }));
        }
        else {
          this.store.dispatch(invokeLocationPartners());
        }
        this.modalService.dismissAll();
        this.closeModal.next(true);
        this.store.dispatch(
          createLocationPartnerSuccess({ successMessage: null })
        );
      }
    });

    this.pricingMethod = Object.keys(PricingMethod)
      .filter((value) => isNaN(Number(value)) === true)
      .map((key: string | any) => ({
        id: PricingMethod[key as keyof typeof PricingMethod],
        value: PricingMethodEnumMapping[key as keyof typeof PricingMethod],
      }));

    this.partnerStatus = Object.keys(PartnerStatus)
      .filter((value) => isNaN(Number(value)) === true)
      .map((key: string | any) => ({
        id: PartnerStatus[key as keyof typeof PartnerStatus],
        value: PartnerStatusToShow[key as keyof typeof PartnerStatus],
      }));

    this.internetProvider = Object.keys(InternetProvider)
      .filter((value) => isNaN(Number(value)) === true)
      .map((key: string | any) => ({
        id: InternetProvider[key as keyof typeof InternetProvider],
        value: InternetProvidersToShow[key as keyof typeof InternetProvider],
      }));

    this.paymentFrequency = Object.keys(PaymentFrequency)
      .filter((value) => isNaN(Number(value)) === true)
      .map((key: string | any) => ({
        id: PaymentFrequency[key as keyof typeof PaymentFrequency],
        value:
          PaymentFrequencyEnumMapping[key as keyof typeof PaymentFrequency],
      }));

    this.formFilter.valueChanges.subscribe((value) => {
      this.pageNumber = 1;
      this.pageSize = Constants.defaultTableSize;
      this.locationPartnerFilter = {
        ...this.locationPartnerFilter,
        companyName: value.companyName,
        pager: {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        },
      };
      this.loadData();
    });
  }

  loadData() {
    this.store.dispatch(invokeApiDistroyed());
    this.store.dispatch(
      invokeLocationPartnerFilter({
        locationPartnerFilter: {
          ...this.locationPartnerFilter,
          partnerStatus: this.optionSelected,
          excludeFranchised: true
        },
      })
    );
  }
  getLocationPartnerPricingMethodValue(
    id: PricingMethod
  ): PricingMethod | undefined {
    return this.pricingMethod.find((item) => item.id == id)?.id;
  }
  removeFilter() {
    this.formFilter.reset({
      companyName: "",
    });
    this.store.dispatch(
      invokeLocationPartnerFilter({
        locationPartnerFilter: {
          ...initialState.locationPartnerFilter,
          pager: {
            pageSize: this.pageSize,
            pageNumber: this.pageNumber,
          },
        },
      })
    );
  }

  //Pagination Config
  changePage(event: number) {
    this.pageNumber = event;
    this.locationPartnerFilter = {
      ...this.locationPartnerFilter,
      pager: {
        ...this.locationPartnerFilter.pager,
        pageNumber: this.pageNumber,
      },
    };
    this.loadData();
  }

  itemsPerPageChange(pageSize: number) {
    this.pageSize = pageSize;
    this.pageNumber = 1;
    this.locationPartnerFilter = {
      ...this.locationPartnerFilter,
      pager: {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      },
    };
    this.loadData();
  }

  //sort table
  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (column != header.sortable) {
        header.direction = "";
      }
    });
    var col: string | null = column;
    var sort = null;
    switch (direction) {
      case "asc":
        sort = true;
        break;
      case "desc":
        sort = false;
        break;
      default:
        sort = true;
        col = null;
    }
    this.locationPartnerFilter = {
      ...this.locationPartnerFilter,
      sortName: column,
      isAscending: sort,
    };
    this.loadData();
  }

  onClickDeleteLocationPartner() {
    this.store.dispatch(
      invokeDeleteLocationPartner({
        email: this.locationPartner.email,
      })
    );
  }
  onClickShowDetails(
    showRouterDetailsModal: any,
    locationPartner: LocationPartnerInterface
  ) {
    const modalRef = this.modalService.open(showRouterDetailsModal);
    this.locationPartner = locationPartner;
  }
  //Modals
  showDeleteModal(deleteModal: any, locationPartner: LocationPartnerInterface) {
    const modalRef = this.modalService.open(deleteModal);
    this.locationPartner = locationPartner;
  }

  findOption(option: string | null) {
    let filter: PartnerStatus | null = null;
    const KeyFound = Object.keys(PartnerStatusToShow).find(
      (key) => PartnerStatusToShow[key as PartnerStatus] === option
    );
    switch (KeyFound) {
      case PartnerStatus.INTERNET_PROVIDER_PAYMENT:
        filter = PartnerStatus.INTERNET_PROVIDER_PAYMENT;
        break;
      case PartnerStatus.REVENUE_SHARING:
        filter = PartnerStatus.REVENUE_SHARING;
        break;
      default:
        filter = null;
    }
    return filter;
  }
  saveOptionFilter(option: string | null) {
    this.pageNumber = 1;
    this.findOption(option);
    this.optionSelected = this.findOption(option);
    this.locationPartnerFilter = {
      ...this.locationPartnerFilter,
      partnerStatus: this.optionSelected,
      pager: {
        ...this.locationPartnerFilter.pager,
        pageNumber: 1,
      },
    };
    this.loadData();
  }
  saveOption(action: ActionReturned, location: LocationPartnerInterface) {
    switch (action.option.type) {
      case OptionActionEnum.ADMIN_LOCATION_DELETE: {
        const modal = this.modalService.open(DeleteComponent, {
          centered: true,
        });
        modal.componentInstance.name = "pop-up.lp.title";
        modal.componentInstance.reference = location.email;
        modal.componentInstance.title = "LPOptions.delete";
        modal.componentInstance.type = OptionActionEnum.ADMIN_LOCATION_DELETE;
        break;
      }
      case OptionActionEnum.ADMIN_LOCATION_DETAILS: {
        const modal = this.modalService.open(DetailsLpComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.locationPartner = location;
        modal.componentInstance.title = "LPOptions.details";
        modal.componentInstance.isFranchised = this.isFranchise;
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.LOCATION_DETAILS
        );
        break;
      }
      case OptionActionEnum.ADMIN_LOCATION_UPDATE: {
        this.store.dispatch(saveUpdateFields({ options: this.updateLocation }));
        const modal = this.modalService.open(UpdateComponent, {
          centered: true,
          size: this.isFranchise ? "lg" : "xl",
        });
        modal.componentInstance.type = TypeCards.ADMIN_LOCATION_UPDATE;
        modal.componentInstance.isCol4 = this.isFranchise;
        modal.componentInstance.title = "LPOptions.update";
        modal.componentInstance.email = location.email;
        modal.componentInstance.locationPartner = location;
        modal.componentInstance.isFranchised = this.isFranchise;
        modal.componentInstance.isMissingStatusData = location.partnerStatus === null ||
        (location.partnerStatus === PartnerStatus.REVENUE_SHARING && location.pilotPhaseEndDate === null) ||
        (location.partnerStatus === PartnerStatus.INTERNET_PROVIDER_PAYMENT && location.paymentFrequency === null);
        modal.componentInstance.isMissingRouterData =
          !location.sessionTimeoutInMinutes || !location.routerBrand;
        break;
      }
      case OptionActionEnum.ADMIN_LOCATION_FEATURES: {
        const modal = this.modalService.open(FeaturesComponent, {
          centered: true,
        });
        modal.componentInstance.userEmail = location.email;
        modal.componentInstance.title = "LPOptions.features";
        modal.componentInstance.companyName = location.companyName;
        modal.componentInstance.isFranchised = this.isFranchise;
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.PATCH,
          UserHistoryServicesEnum.FEATURES
        );
        break;
      }
      case OptionActionEnum.ADMIN_LOCATION_VOUCHER: {
        const modal = this.modalService.open(VouchersComponent, {
          centered: true,
          size: "xl",
        });
        modal.componentInstance.locationPartnerEmail = location.email;
        modal.componentInstance.title = "LPOptions.voucher";
        modal.componentInstance.mode = "dialog";
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.LOCATION_DETAILS
        );
        modal.componentInstance.closeTheModal.subscribe((value: boolean) =>
          modal.close()
        );
        break;
      }
      case OptionActionEnum.ADMIN_LOCATION_API_KEY: {
        const modal = this.modalService.open(ApiKeyComponent, {
          centered: true,
          size: "xl",
        });
        modal.componentInstance.email = location.email;
        modal.componentInstance.hideKey = true;
        break;
      }
      case OptionActionEnum.ADMIN_LOCATION_UPDATE_PASSWORD: {
        const modal = this.modalService.open(UpdatePasswordComponent, {
          centered: true,
        });
        modal.componentInstance.companyName = location.companyName;
        modal.componentInstance.email = location.email;
        modal.componentInstance.closeTheModal.subscribe((value: boolean) => {
          if (value) {
            modal.close();
          }
        });
        break;
      }

      case OptionActionEnum.ADMIN_USER_ARCHIVE: {
        this.archiveOrActivateUser(
          location,
          "pop-ups_Message.confirmationModal.targets.locationPartner.actions.archive.title",
          "pop-ups_Message.confirmationModal.targets.locationPartner.actions.archive.label"
        );
        break;
      }

      case OptionActionEnum.ADMIN_USER_REACTIVATE: {
        this.archiveOrActivateUser(
          location,
          "pop-ups_Message.confirmationModal.targets.locationPartner.actions.reactivate.title",
          "pop-ups_Message.confirmationModal.targets.locationPartner.actions.reactivate.label"
          );
        break;
      }
      case OptionActionEnum.ADMIN_VIEW_APPROBATION: {
        const modal = this.modalService.open(ApprobationProgressComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.isLocation = true;
        modal.componentInstance.locationName = location.companyName;
        modal.componentInstance.isActiveLocation = this.getActiveStaus(location) === FranchiseStatus.ACTIVE;
        modal.componentInstance.closeTheModal.subscribe((value: boolean) =>
          modal.close()
        );
        break;
      }
    }
  }

  archiveOrActivateUser(
    locationPartner: LocationPartnerInterface,
    title: string,
    actionLabel: string
  ) {
    this.archiveModal = this.modalService.open(ConfirmationModalComponent, {
      centered: true,
    });
    this.archiveModal.componentInstance.title = title;
    this.archiveModal.componentInstance.actionLabel = actionLabel;
    this.archiveModal.componentInstance.targetType =
      "pop-ups_Message.confirmationModal.targets.locationPartner.label";
    this.archiveModal.componentInstance.targetName =
      locationPartner.companyName;
    this.archiveModal.componentInstance.confirmAction.subscribe(
      (value: boolean) => {
        if (value) {
          this.store.dispatch(
            invokeArchiveUser({ email: locationPartner.email })
          );
          this.saveHistory.saveUserHistory(
            UserHistoryActionsEnum.PATCH,
            UserHistoryServicesEnum.ADMIN_ARCHIVE_LOCATION_PARTNER
          );
        }
      }
    );
    this.archiveModal.componentInstance.closeModal.subscribe((value: boolean) =>
      this.archiveModal.close()
    );
  }

  onClickShowModal() {
    this.store.dispatch(saveUpdateFields({ options: this.createLocation }));
    this.store.dispatch(updateFields({ fields: this.update }));
    if (this.isFranchise && this.roleName === RoleEnum.ROLE_ADMIN) {
      const modalRef = this.modalService.open(UpdateComponent, {
        centered: true,
        size: this.isFranchise ? "md" : "xl",
      });
      modalRef.componentInstance.type = TypeCards.ADMIN_LOCATION_CREATE;
      modalRef.componentInstance.selectedOption = TypeCards.ADMIN_LOCATION_CREATE;
      modalRef.componentInstance.isCol4 = true;
      modalRef.componentInstance.title = "addLP.title";
      modalRef.componentInstance.isConfirmButton = false
      modalRef.componentInstance.isFranchised = this.isFranchise;
    }
    else {
      const modalRef = this.modalService.open(
          CreateLocationPartnerComponent,
          {
            centered: true,
          }
        );
        if (this.roleName === RoleEnum.ROLE_FRANCHISE) {
          modalRef.componentInstance.selectedOption = OptionActionEnum.ADMIN_CREATE_FRANCHISED;
          modalRef.componentInstance.isFranchised = true;
        }
        else {
          modalRef.componentInstance.selectedOption = OptionActionEnum.ADMIN_CREATE_SIMPLE_LOCATION;
        }
    }
  }
  showModal() {
    const modalRef = this.modalService.open(ExportComponent, {
      centered: true,
    });
  }
  exportCSV(exportModal: any) {
    this.modalService.open(exportModal, {
      centered: true,
    });
  }

  exportToCsv() {
    const csvData = this.convertToCsv();
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
    saveAs(blob, `${this.translate.instant("exportLP.title")}.csv`);
    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.GET,
      UserHistoryServicesEnum.EXPORT_LOCATION_PARTNERS
    );
  }
  convertToCsv() {
    const csvRows: string[] = [];
    let headers;
    let subHeaders;
    headers = this.isFranchise ? [] : [
      "LP",
      this.translate.instant("admin.locations.repository.demographicData"),
      " ",
      " ",
      " ",
      " ",
      this.translate.instant("admin.locations.repository.informations"),
      " ",
      this.translate.instant("admin.locations.repository.coordinates"),
      " ",
      " ",
      this.translate.instant("admin.locations.repository.discount"),
      " ",
      " ",
    ];
    subHeaders = [
      " ",
      this.translate.instant("admin.locations.repository.region"),
      this.translate.instant("admin.locations.repository.zone"),
      this.translate.instant("admin.locations.repository.category"),
      this.translate.instant("admin.locations.repository.subCategory"),
      this.translate.instant("admin.locations.repository.tags"),
      "Option",
      this.translate.instant("admin.locations.repository.endPhase"),
      this.translate.instant("admin.locations.repository.responsable"),
      this.translate.instant("admin.locations.repository.phone"),
      this.translate.instant("admin.locations.repository.address"),
      this.translate.instant("admin.locations.repository.pricingMethod"),
      this.translate.instant("admin.locations.repository.price"),
      this.translate.instant("admin.locations.repository.priceFrequency"),
    ];
    if (this.isFranchise) {
      subHeaders.push(this.translate.instant("admin.locations.franchise.status"));
    }
    this.locationPartnersResult?.locationPartners.forEach((item) => {
      const row = [
        item.companyName,
        item.region,
        item.zoneName,
        item.category,
        item.subCategories.join(' - '),
        item.tags.join(' - '),
        this.translate.instant("enumMapping.partnerStatus." + (item.partnerStatus ?? "NONE")),
        item.pilotPhaseEndDate,
        item.firstName,
        item.phone,
        item.companyAddress.replace(/,/g,' -'),
        item.pricingMethod,
        item.price,
        this.translate.instant("enumMapping.paymentFrequency." + (item.paymentFrequency ?? "NONE"))
      ];
      if (this.isFranchise) {
        row.push(this.translate.instant("enumMapping.franchiseStatus." + this.getActiveStaus(item)));
      }
      csvRows.push(row.join(","));
    });
    this.modalService.dismissAll();
    return [headers, subHeaders, ...csvRows].join("\n");
  }
  toggleColumn(columnNumber: number) {
    this.columnVisibility[columnNumber] = !this.columnVisibility[columnNumber];
  }
  openMenu(j: number) {
    this.show[j] = !this.show[j];
  }

  getOptions(archiveDate: Date | null): ActionInterface[] {
    return this.options.filter((action) =>
      archiveDate
        ? action.type !== OptionActionEnum.ADMIN_USER_ARCHIVE
        : action.type !== OptionActionEnum.ADMIN_USER_REACTIVATE
    );
  }

  isCollaboratorArchived(archivedDate: Date | null): UserStatus {
    return UtilFunctions.isCollaboratorArchived(archivedDate);
  }
  
  isChecked(companyName: string): boolean {
    return this.selectedLocations.includes(companyName)
  }

  toggleSelect(companyName: string) {
    if (!this.isChecked(companyName)) {
      this.selectedLocations = [...this.selectedLocations, companyName];
    }
    else {
      this.selectedLocations = this.selectedLocations.filter(name => name !== companyName);
    }
  }

  getActiveStaus(location: LocationPartnerInterface): FranchiseStatus {
    return UtilFunctions.getFranchisedActiveStatus(location);
  }

  showCompareModal() {
    const modal = this.modalService.open(CompareModalComponent, {
      centered: true,
      size: this.selectedLocations.length <= 3 ? 'lg' : 'xl'
    })
    modal.componentInstance.locations = this.selectedLocations;

    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.GET,
      UserHistoryServicesEnum.COMPARE_LOCATIONS
    );
  }
}
